import {
	breakpoints,
	colors,
	Flex,
	Icon,
	IconTypes,
	scale,
	Text,
} from "@capioweb/ui-components/src"
import * as React from "react"
import styled from "styled-components"

interface RelatedUnitCardStyledProps {
	firstChild?: boolean
	lastChild?: boolean
}

interface RelatedUnitCardProps extends RelatedUnitCardStyledProps {
	icon: IconTypes
	name: string
}

const Aside = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	background-color: ${colors.blue11};
	min-width: ${scale.px(7)};
	height: 100%;

	svg {
		margin-bottom: auto;
		margin-top: auto;
	}
`

const RelatedUnitCardStyled = styled.div<RelatedUnitCardStyledProps>`
	position: relative;
	display: flex;
	min-height: 78px;
	width: 100%;
	height: 100%;
	background-color: ${colors.white};
	border: 1px solid ${colors.blue33};
	border-radius: ${(props) =>
		props.firstChild
			? `${scale.px(3)} ${scale.px(3)} 0 0`
			: props.lastChild
			? `0 0 ${scale.px(3)} ${scale.px(3)}`
			: "0"};
	overflow: hidden;

	&:hover {
		border-color: ${colors.hoverBlue};

		svg path {
			fill: ${colors.hoverBlue};
		}
		svg: {
			position: "absolute";
			right: scale.px(1.25);
			margin-bottom: auto;
			margin-top: auto;
		}
	}

	@media screen and (min-width: ${breakpoints.m}px) {
		border-radius: ${scale.px(3)};
	}
`

const RelatedUnitCard: React.FC<RelatedUnitCardProps> = ({
	icon,
	name,
	firstChild,
	lastChild,
}) => {
	return (
		<RelatedUnitCardStyled firstChild={firstChild} lastChild={lastChild}>
			{icon && (
				<Aside>
					<Icon icon={icon} size={4} />
				</Aside>
			)}
			<Flex
				justifyContent="space-between"
				w={1}
				my="auto"
				pl={2}
				pr={1.5}
				columnGap={2}
			>
				<Text variant="headline-3" mb={0} truncate="twoLine">
					{name}
				</Text>
				<Flex h={1} my="auto">
					<Icon icon="arrow-right" size={3} />
				</Flex>
			</Flex>
		</RelatedUnitCardStyled>
	)
}

export { RelatedUnitCard }
